module.exports = __webpack_public_path__ + "media/images/logo1-31fb5cc26012eff58f99eca853cb4d03.png";